import { type Common } from '../common.js';
import {
  type LinkCreateValues,
  type LinkUpdateValues,
  type MessageRequestLink,
} from '../models/previsit/messageRequest.js';

export class API {
  common: Common;
  baseEndpoint = '/previsit/message-request-links';

  constructor(common: Common) {
    this.common = common;
  }

  async create(values: LinkCreateValues): Promise<MessageRequestLink> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async findOneById(linkId: string): Promise<MessageRequestLink> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${linkId}`);
    return await this.common.getJSON(url);
  }

  async findAll(): Promise<MessageRequestLink[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { results } = await this.common.getJSON(url);
    return results;
  }

  async update(linkId: string, values: LinkUpdateValues): Promise<MessageRequestLink> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${linkId}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(linkId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${linkId}`);
    return await this.common.deleteJSON(url);
  }
}
